import React, { useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import SvgSprite from './SvgSprite';
import { query, setSearchQuery } from '../Actions/QuickSearch.action';
import { debounce } from 'lodash-es';

const debouncedQuery = debounce((dispatch, text) => dispatch(query(text)), 200);

const QuickSearch = () => {
    const { query } = useSelector((state) => state.quickSearch);
    const searchUrl = window.__litium.quickSearchUrl + (query.length > 0 ? `?q=${query}` : '');
    const searchInput = useRef(null);
    const dispatch = useDispatch();
    const [searchText, setSeachText] = useState("");
    const searchResultsPopover = document.querySelector('#search-results');
    const isAuthenticated = window.__litium.constants.isAuthenticated;
    const showQuickBuy = !!(window.__litium.quickAddToCartTemplateUrl)

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('q')) {
            const query = urlParams.get('q');
            dispatch(setSearchQuery(query));
        }
    }, [dispatch]);

    useEffect(() => {
        if(searchResultsPopover) {
            searchText !== "" ? searchResultsPopover.showPopover() : searchResultsPopover.hidePopover();
        }
    }, [searchText]);

    return (
        <div className='quick-search' role='search'>
            <label className='quick-search__input'>
                <SvgSprite iconId="Search" />
                <input className='quick-search__input' type='search' placeholder={translate('general.searchplaceholder')}
                    autoComplete='off' name='search-query' value={decodeURIComponent(query)}
                    onChange={(event) => {
                        const text = encodeURIComponent(event.target.value);
                        setSeachText(text);
                        dispatch(setSearchQuery(text));
                        debouncedQuery(dispatch, text);
                    }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            window.location.href = searchUrl;
                        }
                    }}
                    ref={searchInput}
                />
            </label>
            <button className='button' type='submit' onClick={(e) => { e.preventDefault(); window.location.href = searchUrl; }}                >
                {translate('general.search')}
            </button>
            {isAuthenticated && showQuickBuy && 
                <button className="button button--orange" popoverTarget="quick-add">
                    {translate("headeraddtocart.orderbuttontext")}
                </button>
            }
        </div>
    );
};

export default QuickSearch;
